<template>
  <div class="mmg-storefront mmg-about-page fusion-body">
    <div id="wrapper">
      <SiteHeader />

      <div
        class="fusion-page-title-bar fusion-page-title-bar-none fusion-page-title-bar-left"
      >
        <div class="fusion-page-title-row">
          <div class="fusion-page-title-wrapper">
            <div class="fusion-page-title-captions">
              <h1 class="entry-title">{{ $t('about.title') }}</h1>
            </div>
            <div class="fusion-page-title-secondary">
              <div class="fusion-breadcrumbs">
                <router-link to="/">{{ $t('common.home') }}</router-link>
                <span class="fusion-breadcrumb-sep">/</span>
                <span class="breadcrumb-leaf">{{ $t('about.title') }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <main id="main" role="main" class="clearfix width-100">
        <div class="fusion-row about-row-max">
          <section id="content" class="full-width about-content">
            <article class="page type-page status-publish hentry">
              <div class="post-content">
                <section class="fusion-fullwidth about-section">
                  <div class="fusion-builder-row fusion-row">
                    <div class="fusion-layout-column fusion-one-full about-column">
                      <div class="fusion-column-wrapper">
                        <div
                          class="fusion-title fusion-title-size-two fusion-border-below-title"
                        >
                          <h2 class="title-heading-left about-section-title">
                            <strong>{{ $t('about.sectionTitle') }}</strong>
                          </h2>
                          <div class="title-sep-container">
                            <div class="title-sep sep-single sep-solid" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                <section class="fusion-fullwidth about-section">
                  <div class="fusion-builder-row fusion-row">
                    <div class="fusion-layout-column fusion-one-full about-column">
                      <div class="fusion-column-wrapper">
                        <div class="fusion-text about-body">
                          <p>{{ $t('about.intro') }}</p>
                          <ul>
                            <li v-for="(text, index) in aboutBullets" :key="'bullet-' + index">
                              <p v-if="index === 0">{{ text }}</p>
                              <template v-else>{{ text }}</template>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                <section class="fusion-fullwidth about-section about-section--actions">
                  <div class="fusion-builder-row fusion-row">
                    <div class="fusion-layout-column fusion-one-full about-column">
                      <div class="fusion-column-wrapper about-actions">
                        <div class="fusion-button-wrapper fusion-alignleft">
                          <router-link
                            to="/contact"
                            class="fusion-button button-flat fusion-button-round button-large button-default button-1"
                          >
                            <span class="fusion-button-text">{{ $t('about.contactTeam') }}</span>
                          </router-link>
                        </div>
                        <div class="fusion-button-wrapper fusion-alignleft">
                          <router-link
                            to="/products"
                            class="fusion-button button-flat fusion-button-round button-large button-default button-2"
                          >
                            <span class="fusion-button-text">{{ $t('about.viewProducts') }}</span>
                          </router-link>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </article>
          </section>
        </div>
      </main>

      <SiteFooter />
    </div>
  </div>
</template>

<script>
import SiteHeader from '@/components/SiteHeader.vue'
import SiteFooter from '@/components/SiteFooter.vue'

export default {
  name: 'AboutPage',
  components: { SiteHeader, SiteFooter },
  computed: {
    aboutBullets() {
      void this.currentLocale
      return this.$tm('about.bullets') || []
    }
  },
  mounted() {
    document.body.classList.add('about')
    document.title = this.$t('pageTitle.about')
  },
  watch: {
    currentLocale() {
      document.title = this.$t('pageTitle.about')
    }
  },
  beforeUnmount() {
    document.body.classList.remove('about')
  }
}
</script>

<style scoped>
.about-content {
  width: 100%;
}

.about-row-max {
  max-width: 100%;
}

.about-section {
  padding: 20px 30px;
}

.about-section--actions {
  padding-bottom: 40px;
}

.about-section-title {
  margin: 0 0 31px;
  font-size: 26px;
  font-weight: 400;
  color: var(--mmg-heading, #333);
}

.about-body p {
  margin: 0 0 1em;
  line-height: 1.7;
}

.about-body ul {
  margin: 0 0 1.25em;
  padding-left: 1.5em;
}

.about-body li {
  margin-bottom: 1em;
  line-height: 1.7;
}

.about-body li p {
  margin: 0;
}

.about-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 12px 16px;
  align-items: center;
}

.about-actions .fusion-button-wrapper {
  margin: 0;
}
</style>
